import Const from 'const';
import ParserInterface from './parser-interface';

class Parser implements ParserInterface {
    // Double quotes as the first/last symbol of a string and line breaks.
    private lineBreaksRegex = /(\r\n|\n|\r)/g;
    private doubleQuotesRegex = /(^"|"$)/g;

    constructor(
        private rowSeparator: string = Const.LATESWAP_CSV_ROW_SEPARATOR,
        private cellSeparator: string = Const.LATESWAP_CSV_CELL_SEPARATOR,
    ) {}

    parse(content: string): string[][] {
        const rows = this.splitContentByRows(content);
        let parsedContent = rows.map((row: string) => this.splitRowByCells(row));

        return [...parsedContent];
    }

    private splitContentByRows(content: string): string[] {
        return content.split(this.rowSeparator);
    }

    private splitRowByCells(row: string): string[] {
        return row.split(this.cellSeparator).map((cellContent) => this.filterCellContent(cellContent));
    }

    private filterCellContent(cellContent: string): string {
        return cellContent.replace(this.lineBreaksRegex, '').replace(this.doubleQuotesRegex, '');
    }
}

export default Parser;
